import { Site } from "@datadog/browser-core/cjs/domain/configuration";
import { DefaultPrivacyLevel } from "@datadog/browser-rum";

export const environment = {
  production: false,
  useApi: true,
  //baseUri: 'http://localhost:3000/',
  //useApi: false,
  baseUri: 'https://api.vibes2-dev.apps4.icldig.icl-group.com/',
  dataApiEndpoint: 'getPaperChart',
  stocksAPIUrl: 'globes-api/getAllPapers',
  histogramStockAPIUrl: `globes-api/getPaperChart?paperid={{paperId}}`,
  adalConfig: {
    clientId: '4331a39e-68e4-4ab8-b58b-66e0e9ad4168',
    issuer: 'https://login.microsoftonline.com/802762d2-02c4-4677-98ba-54060a234204/v2.0',
    strictDiscoveryDocumentValidation: false,
    responseType: 'id_token token',
    scope: '4331a39e-68e4-4ab8-b58b-66e0e9ad4168/.default',
  },
  DatadogRum:{
            applicationId: 'e7356648-61ba-4384-8a4f-94760c288b93',
            clientToken: 'pub07a283f508fa491f977d907127ee548b',
            site: 'datadoghq.eu' as Site,
            service: 'vibes_dev',
            env: 'dev',
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
            allowedTracingUrls:['https://api.vibes2-dev.apps4.icldig.icl-group.com/'],
  },
  version: '3.0.5',
};
